module.exports = __webpack_public_path__ + "assets/iot-white.4b04e835.svg";